import * as React from "react";

import {
    showCtaAndLegalSections,
    contactInfoAddressHasServerSideErrors,
    contactInfoZipCodeHasServerSideErrors,
    contactInfoPhoneHasServerSideErrors,
    formatPhoneNumber,
    formatPhoneNumberForStateUpdate,
    cleanUpNumericValue,
    sectionClasses
} from "../common/Utils";
import { QuoteFormEventType } from "../../../Common/QuoteFormEventTracking/QuoteFormEventType";

import { IStepProps } from "../interfaces/IStepProps";
import { IStepState } from "../interfaces/IStepState";
import { IAutoWizardModel } from "../interfaces/IAutoWizardModel";

import { LogStep } from "../../../Common/QuoteFormEventTracking/LogStep";

interface IContactInfoAddressStepState extends IStepState {
    address?: string;
    address2?: string;
    zip?: string;
    phone?: string;
    phoneFormatted?: string,
    latitude?: string;
    longitude?: string;
    addressError?: string;
    zipError?: string;
    phoneError?: string;
}

declare var enableAutoComplete: boolean;
declare var google: any;
declare var latitude: any;
declare var longitude: any;

export class ContactInfoAddressStep extends React.Component<IStepProps, IContactInfoAddressStepState> {

    state: IContactInfoAddressStepState;

    autocomplete: any;

    constructor(props: IStepProps) {
        super(props);

        this.state = {
            address: this.props.model.contactInfo.address,
            address2: this.props.model.contactInfo.address2,
            zip: this.props.model.contactInfo.zipCode,
            phone: cleanUpNumericValue(this.props.model.contactInfo.phoneDay),
            phoneFormatted: formatPhoneNumber(this.props.model.contactInfo.phoneDay),
            redirectPath: "",
            latitude: "",
            longitude: "",
            addressError: contactInfoAddressHasServerSideErrors("ContactInfo_Address") ? "Your address is required" : "",
            zipError: contactInfoZipCodeHasServerSideErrors("ContactInfo_ZipCode") ? "Please enter a valid zip code" : "",
            phoneError: contactInfoPhoneHasServerSideErrors("ContactInfo_PhoneDay") ? "Please enter a valid phone number" : "",
            goToNextStep: false
        }
        
        showCtaAndLegalSections();
    }

    componentDidMount() {
        if (enableAutoComplete) {

            this.autocomplete = new google.maps.places.Autocomplete(
                document.getElementById('ContactInfoAddress_Address'), { types: ['geocode'], componentRestrictions: { country: 'usa' } });

            this.autocomplete.setFields(['address_component']);

            if (latitude && longitude) {
                var geolocation = {
                    lat: parseInt(latitude),
                    lng: parseInt(longitude) * -1
                };

                var circle = new google.maps.Circle(
                    { center: geolocation, radius: 10000 });

                this.autocomplete.setBounds(circle.getBounds());
            }

            this.autocomplete.addListener('place_changed', this.fillInAddress);
        }
    }

    fillInAddress = () => {

        var componentForm: any = {
            street_number: 'short_name',
            route: 'long_name',
            locality: 'long_name',
            administrative_area_level_1: 'short_name',
            postal_code: 'short_name'
        };

        var addressComponents: any = {
            street_number: '',
            route: '',
            locality: '',
            administrative_area_level_1: '',
            postal_code: ''
        };

        var place = this.autocomplete.getPlace();

        for (var i = 0; i < place.address_components.length; i++) {
            var addressType: any = place.address_components[i].types[0];
            if (componentForm[addressType]) {
                var val: any = place.address_components[i][componentForm[addressType]];
                addressComponents[addressType] = val;
            }
        }

        var address = addressComponents["street_number"] + " " + addressComponents["route"];
        var zip = addressComponents["postal_code"];

        let model: IAutoWizardModel = JSON.parse(JSON.stringify(this.props.model));

        model.contactInfo.address = address;
        model.contactInfo.zipCode = zip;
        model.contactInfo.addressStatus = this.updateAddressStatus("autoCompleted");

        this.props.onUpdateModel(model);

        this.setState({ address: address, zip: zip });        
    }

    updateAddressStatus = (update: string) => {

        //    Raw = 0,
        //    LocalLeadScrubbing = 1,
        //    NeustarNormalized = 2,
        //    GoogleMapsAutoCompleted = 3,
        //    GoogleMapsAutoCompletedButEdited = 4,
        //    GoogleMapsGeoCodingApi = 5
        var currentStatus = this.props.model.contactInfo.addressStatus;

        if (update === "autoCompleted") {
            return "3";
        }
        else if (update === "editedInput" && currentStatus === "3") {
            return "4";
        }

        return currentStatus;
    }

    handleOnInputAddress = (event: React.FormEvent<HTMLInputElement>) => {
        let valueElement = event.target as HTMLInputElement;
        let value = valueElement.value;

        let model: IAutoWizardModel = JSON.parse(JSON.stringify(this.props.model));

        model.contactInfo.address = value;

        this.props.onUpdateModel(model);

        this.setState({ address: value });
    }
    

    handleOnInputAddress2 = (event: React.FormEvent<HTMLInputElement>) => {
        let valueElement = event.target as HTMLInputElement;
        let value = valueElement.value;

        let model: IAutoWizardModel = JSON.parse(JSON.stringify(this.props.model));

        model.contactInfo.address2 = value;

        this.props.onUpdateModel(model);

        this.setState({ address2: value });
    }
    
    handleOnInputZip = (event: React.FormEvent<HTMLInputElement>) => {
        let valueElement = event.target as HTMLInputElement;
        let value = valueElement.value;

        let model: IAutoWizardModel = JSON.parse(JSON.stringify(this.props.model));

        const cleanZipCode = cleanUpNumericValue(value);

        model.contactInfo.zipCode = cleanZipCode;

        this.props.onUpdateModel(model);

        this.setState({ zip: cleanZipCode });
    }
    
    handleOnChangeAddress = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ address: event.target.value });
    }
    
    handleOnChangeAddress2 = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ address2: event.target.value });
    }

    handleOnChangeZip = (event: React.ChangeEvent<HTMLInputElement>) => {
        const cleanZipCode = cleanUpNumericValue(event.target.value);
        this.setState({ zip: cleanZipCode });
    }

    handleOnChangePhone = (value: string) => {
        let model: IAutoWizardModel = JSON.parse(JSON.stringify(this.props.model));

        const cleanPhoneNumber = cleanUpNumericValue(value);

        model.contactInfo.phoneDay = cleanPhoneNumber;

        this.props.onUpdateModel(model);

        this.setState(prevState => ({ phoneFormatted: formatPhoneNumberForStateUpdate(value, prevState.phone), phone: cleanPhoneNumber }));
    }
    
    validateInput = (inputValue: string) => {
        if (0 === inputValue.length) {
            return false;
        } 

        return true;
    }

    validateZipCode = (zipInputValue: string) => {
        if (0 === zipInputValue.length) {
            return false;
        } 

        if (!/^\d{3,5}$/.test(zipInputValue)) {
            return false;
        } 

        return true;
    }

    render(): JSX.Element {

        const sectionStyle = {
            display: 'block'
        }

        const addressError = this.state.addressError.length > 0 ? <span id="ContactInfoAddress_Address_Error" className="field-invalid-text">{this.state.addressError}</span> : "";
        const zipError = this.state.zipError.length > 0 ? <span id="ContactInfoAddress_Zip_Error" className="field-invalid-text">{this.state.zipError}</span> : "";
        const phoneError = this.state.phoneError.length > 0 ? <span id="ContactInfoAddress_Phone_Error" className="field-invalid-text">{this.state.phoneError}</span> : "";

        return <React.Fragment>
            <LogStep lastStep="ContactInfoName" nextStep="EXIT" stepNumber={QuoteFormEventType.ContactInfoLastStep} sectionName="ContactInfoAddress" wizardName="AutoWizard" logStep={true}/>
            <div id="ContactInfoAddressStep" className={sectionClasses} style={sectionStyle}>
                <div id="ContactInfoAddress">
                    <div id="google_autocomplete" className="street-address">
                        {addressError}
                        <input type="text" id="ContactInfoAddress_Address" placeholder="Address" maxLength={200} onChange={this.handleOnChangeAddress} onInput={this.handleOnInputAddress} value={this.state.address} />
                    </div>
                    {zipError}
                    <div className="address2">
                        <input type="text" id="ContactInfoAddress_Address2" placeholder="Apt, Unit" maxLength={50} onChange={this.handleOnChangeAddress2} onInput={this.handleOnInputAddress2} value={this.state.address2} />
                    </div>
                    <div className="zip-address">
                        <input type="tel" id="ContactInfoAddress_Zip" placeholder="Zip" maxLength={5} onChange={this.handleOnChangeZip} onInput={this.handleOnInputZip} value={this.state.zip} />
                    </div>
                    <div className="phone">
                        {phoneError}
                        <input type="hidden" id="ContactInfoAddress_Phone" value={this.state.phone} />
                        <input type="tel" id="ContactInfoAddress_PhoneFormatted" placeholder="(555) 555-5555" maxLength={14} value={this.state.phoneFormatted} onChange={(event: React.ChangeEvent<HTMLInputElement>) => this.handleOnChangePhone(event.target.value)} />
                    </div>
                </div>
            </div>
        </React.Fragment>;
    }
}